import React, { useContext, useEffect } from 'react';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import ProgressContext from '@mirinae/lessons/modules/contexts/progress';

import { UserAgent } from '@mirinae/js-utils';
import DefaultPage from './DefaultPage';

const isMobile = !UserAgent.os.isOthers;

const MiniLessonTable = ({ page }) => {
    const player = useContext(PlayerContext);
    const progress = useContext(ProgressContext);

    const miniLessonSections = player.currentStep.children
        .filter(e => e.componentName === 'miniLessonTableCard')
        .map(mlc => player.findSection(mlc.fieldsByName.section.value));

    const progressValue = (section) => (section && progress.sections[section.nodeID] ? progress.sections[section.nodeID].progress : 0);
    
    player.registerNavigation({
        skipOrNext: () => {
            const miniLessonsCompleted = miniLessonSections.reduce((mlc, s) => mlc + (progressValue(s) === 100 ? 1 : 0), 0) || 0;
            return miniLessonsCompleted < miniLessonSections.length ? 'skip' : 'next';
        },
    });

    useEffect(() => () => player.registerNavigation(null));

    return <DefaultPage page={page} />;

};

export default MiniLessonTable;
